/* storybook-check-ignore */
import React from 'react';
import { Box, Text } from '@opendoor/bricks/core';

const PropertyDetail: React.FC<{
  title: string;
  value: string;
}> = ({ title, value }) => {
  return (
    <Box>
      <Text lineHeight="s1" fontSize="s1" color="neutrals90" mb={['0.5rem', '0.5rem', '0.5rem', 0]}>
        {title}
      </Text>
      <Text lineHeight="s1" fontWeight="semibold" fontSize="s1">
        {value}
      </Text>
    </Box>
  );
};

export default PropertyDetail;
